// Mock org structure for the demo Org Chart. Tree-shaped (each person
// has a `reportsTo` id) so a recursive renderer can lay it out.

export const ORG = {
  organization: { id: 'org_scaletime', name: 'ScaleTime' },
  departments: [
    { id: 'dept_exec',  name: 'Executive',  colorName: 'darkblue' },
    { id: 'dept_ops',   name: 'Operations', colorName: 'brand' },
    { id: 'dept_sales', name: 'Sales',      colorName: 'violet' },
    { id: 'dept_mkt',   name: 'Marketing',  colorName: 'pink' },
    { id: 'dept_fin',   name: 'Finance',    colorName: 'green' },
    { id: 'dept_eng',   name: 'Engineering', colorName: 'brightblue' },
  ],
  people: [
    // Exec
    { id: 'p_ceo',        name: 'Manzil Zaheer',  role: 'CEO',                 department: 'dept_exec',  reportsTo: null,        avatarColor: 'darkblue' },

    // Operations
    { id: 'p_vp_ops',     name: 'Priya Shah',     role: 'VP, Operations',      department: 'dept_ops',   reportsTo: 'p_ceo',     avatarColor: 'brand' },
    { id: 'p_mgr_serv',   name: 'Carlos Mendez',  role: 'Manager, Servicing',  department: 'dept_ops',   reportsTo: 'p_vp_ops',  avatarColor: 'brand' },
    { id: 'p_coord_1',    name: 'Emily Tran',     role: 'Senior Coordinator',  department: 'dept_ops',   reportsTo: 'p_mgr_serv', avatarColor: 'brand' },
    { id: 'p_coord_2',    name: 'Jason Park',     role: 'Coordinator',         department: 'dept_ops',   reportsTo: 'p_mgr_serv', avatarColor: 'brand' },
    { id: 'p_mgr_prod',   name: 'Nadia Rahman',   role: 'Manager, Production', department: 'dept_ops',   reportsTo: 'p_vp_ops',  avatarColor: 'brand' },
    { id: 'p_lead_prod',  name: 'Marcus Webb',    role: 'Production Lead',     department: 'dept_ops',   reportsTo: 'p_mgr_prod', avatarColor: 'brand' },

    // Sales
    { id: 'p_vp_sales',   name: 'David Liu',      role: 'VP, Sales',           department: 'dept_sales', reportsTo: 'p_ceo',     avatarColor: 'violet' },
    { id: 'p_ae_1',       name: 'Sofia Alvarez',  role: 'Account Executive',   department: 'dept_sales', reportsTo: 'p_vp_sales', avatarColor: 'violet' },
    { id: 'p_ae_2',       name: 'Tom O’Brien',   role: 'Account Executive',   department: 'dept_sales', reportsTo: 'p_vp_sales', avatarColor: 'violet' },
    { id: 'p_sdr_1',      name: 'Hannah Lee',     role: 'SDR',                 department: 'dept_sales', reportsTo: 'p_vp_sales', avatarColor: 'violet' },

    // Marketing
    { id: 'p_vp_mkt',     name: 'Aisha Patel',    role: 'VP, Marketing',       department: 'dept_mkt',   reportsTo: 'p_ceo',     avatarColor: 'pink' },
    { id: 'p_mkt_mgr',    name: 'Riley Chen',     role: 'Marketing Manager',   department: 'dept_mkt',   reportsTo: 'p_vp_mkt',  avatarColor: 'pink' },

    // Finance
    { id: 'p_cfo',        name: 'Rachel Kim',     role: 'CFO',                 department: 'dept_fin',   reportsTo: 'p_ceo',     avatarColor: 'green' },
    { id: 'p_controller', name: 'Jordan Blake',   role: 'Controller',          department: 'dept_fin',   reportsTo: 'p_cfo',     avatarColor: 'green' },

    // Engineering
    { id: 'p_cto',        name: 'Binit Malla',    role: 'CTO',                 department: 'dept_eng',   reportsTo: 'p_ceo',     avatarColor: 'brightblue' },
    { id: 'p_eng_lead',   name: 'Yusuf Ahmed',    role: 'Engineering Lead',    department: 'dept_eng',   reportsTo: 'p_cto',     avatarColor: 'brightblue' },
    { id: 'p_eng_1',      name: 'Mei Zhang',      role: 'Senior Engineer',     department: 'dept_eng',   reportsTo: 'p_eng_lead', avatarColor: 'brightblue' },
  ],
};

// Helper: build a parent → children map for tree rendering.
export function buildOrgTree(people) {
  const byParent = new Map();
  for (const p of people) {
    const key = p.reportsTo || '__root__';
    if (!byParent.has(key)) byParent.set(key, []);
    byParent.get(key).push(p);
  }
  return byParent;
}

export function initials(name) {
  return name
    .split(/\s+/)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
